import React from "react"
import { Main } from "../styles/Container"
import Spinner from "@nvdb-rapport/shared/src/components/Spinner"

export default function AppLoading() {
  return (
    <Main>
      <Spinner />
    </Main>
  )
}
